module.exports = __webpack_public_path__ + "img/config_estimate.7e6e8850.png";